import React from 'react';
import PropTypes from 'prop-types';
import { CustomSelect } from '../PaginationSelect';
import {
  getPerPageOptions,
  MAX_EXACT_TOTAL_OPTION,
} from '../PaginationSelect/PaginationSelect.utils';
import * as S from './PaginationInfo.styles';
import i18n from 'i18next';

const PaginationInfo = ({ total, perPage, totalPages, onToggleClick }) => {
  const options = getPerPageOptions(total);
  const hasPageSizeChoice =
    options.length > 1 &&
    Number(total) <= MAX_EXACT_TOTAL_OPTION &&
    options.includes(Number(perPage));

  if (!(totalPages > 1) && !hasPageSizeChoice) return null;

  return (
    <S.Span data-test="pagination-info-text">
      {i18n.t('commons.tables.pagination.showing')}
      <CustomSelect
        perPage={perPage}
        options={options}
        onToggleClick={onToggleClick}
      />
      {i18n.t('commons.tables.pagination.of')} {total}{' '}
      {i18n.t('commons.tables.pagination.entries')}
    </S.Span>
  );
};

PaginationInfo.propTypes = {
  onToggleClick: PropTypes.func,
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  perPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  totalPages: PropTypes.number,
};

export default PaginationInfo;
